// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { deviceId } from './Device';
import { z } from 'zod';
export const deviceLogEntryId = (z.string());
export const deviceLogEntry = z.object({
    id: deviceLogEntryId,
    device_id: deviceId,
    ts: z.date(),
    kind: z.string(),
    tag: z.string().nullable(),
    value: z.string().nullable(),
    message: z.string().nullable(),
    created_at: z.date(),
});
export const deviceLogEntryInitializer = z.object({
    id: deviceLogEntryId.optional(),
    device_id: deviceId,
    ts: z.date(),
    kind: z.string(),
    tag: z.string().optional().nullable(),
    value: z.string().optional().nullable(),
    message: z.string().optional().nullable(),
    created_at: z.date().optional(),
});
export const deviceLogEntryMutator = z.object({
    id: deviceLogEntryId.optional(),
    device_id: deviceId.optional(),
    ts: z.date().optional(),
    kind: z.string().optional(),
    tag: z.string().optional().nullable(),
    value: z.string().optional().nullable(),
    message: z.string().optional().nullable(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=DeviceLogEntry.js.map